// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__vkz7-","header":"HomePage_header__S45zT","main":"HomePage_main__6R4ZI","cardGrid":"HomePage_cardGrid__nxcGa"};